import Config from "Config";

export const Constant = {
    version: "",
    ReleaseFormArray: [],
    //url
    url: {
        getFormSchema: "/formSchema",
        fileUpload: `${Config.CONTENT_PATH}/attachment/`,
        CYCHonoursSchemePrincipleForm:
            "/sampleResponse/CYCHonoursSchemePrincipleForm.json",
    },
    //action
    action: {
        SET_TOKEN: "SET_TOKEN",
        RESET_TOKEN: "RESET_TOKEN",
        SET_PARSE_DATA: "SET_PARSE_DATA",
        SET_USERTYPE: "SET_USERTYPE",
        SET_FORM_ID: "SET_FORM_ID",
        SET_FORM: "SET_FORM",
        SET_FORM_FIELD_VALUES: "SET_FORM_FIELD_VALUES",
        SET_CURRENT_STEP: "SET_CURRENT_STEP",
        SET_INITIAL_STEP: "SET_INITIAL_STEP",
        INITIAL_FORM: "INITIAL_FORM",
        INITIAL_APPROVAL: "INITIAL_APPROVAL",
        SET_FIELD_VALUES: "SET_FIELD_VALUES",
        SET_FULL_FIELD_VALUS: "SET_FULL_FIELD_VALUS",
        SET_REPLY_SLIP_OPTION: "SET_REPLY_SLIP_OPTION",
        ADD_ATTACHMENT: "ADD_ATTACHMENT",
        CLEAR_ATTACHMENT: "CLEAR_ATTACHMENT",
        DELETE_ATTACHMENT_DONE: "DELETE_ATTACHMENT_DONE",
        TOGGLE_LOGIN_POPUP: "TOGGLE_LOGIN_POPUP",
        TOGGLE_LOGIN_DIALOG: "TOGGLE_LOGIN_DIALOG",
        TOGGLE_LOAD_FORM_POPUP: "TOGGLE_LOAD_FORM_POPUP",
        TOGGLE_APPROVER_EDIT_LOAD_FORM_POPUP:
            "TOGGLE_APPROVER_EDIT_LOAD_FORM_POPUP",
        TOGGLE_MOBILE_NAV: "TOGGLE_MOBILE_NAV",
        TOGGLE_MULTISUBMIT_EDITING: "TOGGLE_MULTISUBMIT_EDITING",
        TOGGLE_ISEXCEEDING_DEADLINE: "TOGGLE_ISEXCEEDING_DEADLINE",
        CLEAR_FORM: "CLEAR_FORM",
        SET_REDIRECT_TO: "SET_REDIRECT_TO",
        RESET_REDIRECT_TO: "RESET_REDIRECT_TO",
        SET_ROLE: "SET_ROLE",
        SET_OPENID: "SET_OPENID",
        SET_EMAIL: "SET_EMAIL",
        UPDATE_ROLE: "UPDATE_ROLE",
        RESET_PROFILE: "RESET_PROFILE",
        SET_USER_ORG: "SET_USER_ORG",
        RESET_USER_ORG: "RESET_USER_ORG",
        SET_SELECTED_USER_ORG: "SET_SELECTED_USER_ORG",
        RESET_SELECTED_USER_ORG: "RESET_SELECTED_USER_ORG",
        SET_CURRENT_WORKFLOW: "SET_CURRENT_WORKFLOW",
        RESET_CURRENT_WORKFLOW: "RESET_CURRENT_WORKFLOW",
        SET_SEARCH_DATA: "SET_SEARCH_DATA",
        RESET_SEARCH_DATA: "RESET_SEARCH_DATA",
        SET_SELECTED_SCRN: "SET_SELECTED_SCRN",
        GET_FORM_TEMP_LANGUAGE: "GET_FORM_TEMP_LANGUAGE",
        GET_APPROVER_EDIT_FORM_LANGUAGE: "GET_APPROVER_EDIT_FORM_LANGUAGE",

        UPDATE_IAS_FIELD: "UPDATE_IAS_FIELD",
        INIT_IAMSMART_IASTOKEN_FIELD_MAP: "INIT_IAMSMART_IASTOKEN_FIELD_MAP",
        INIT_IAMSMART_FIELD_MAP: "INIT_IAMSMART_FIELD_MAP",
        SET_IAMSMART_FIELD_MAP: "SET_IAMSMART_FIELD_MAP",
        SET_APPLICANT_FORM_LIST: "SET_APPLICANT_FORM_LIST",
        RESET_APPLICANT_FORM_LIST: "RESET_APPLICANT_FORM_LIST",

        SET_STEP_SEQUENCE: "SET_STEP_SEQUENCE",
        RESET_STEP_SEQUENCE: "RESET_STEP_SEQUENCE",
        RESET_FORMFILLED: "RESET_FORMFILLED",

        GET_APPLICANT_FORMLIST: {
            REQUEST: "GET_APPLICANT_FORMLIST_REQUEST",
            SUCCESS: "GET_APPLICANT_FORMLIST_SUCCESS",
            FAIL: "GET_APPLICANT_FORMLIST_FAIL",
        },
        IAMSMART_AUTH: {
            REQUEST: "IAMSMART_AUTH_REQUEST",
            SUCCESS: "IAMSMART_AUTH_SUCCESS",
            FAIL: "IAMSMART_AUTH_FAIL",
        },
        IAMSMART_PROFILE: {
            REQUEST: "IAMSMART_PROFILE_REQUEST",
            SUCCESS: "IAMSMART_PROFILE_SUCCESS",
            FAIL: "IAMSMART_PROFILE_FAIL",
        },
        IAMSMART_SIGN: {
            REQUEST: "IAMSMART_SIGN_REQUEST",
            SUCCESS: "IAMSMART_SIGN_SUCCESS",
            FAIL: "IAMSMART_SIGN_FAIL",
        },
        GET_IAMSMART_PROFILE_QR: {
            REQUEST: "GET_IAMSMART_PROFILE_QR_REQUEST",
            SUCCESS: "GET_IAMSMART_PROFILE_QR_SUCCESS",
            FAIL: "GET_IAMSMART_PROFILE_QR_FAIL",
            DONE: "GET_IAMSMART_PROFILE_QR_DONE",
        },
        GET_IAMSMART_PROFILE: {
            REQUEST: "GET_IAMSMART_PROFILE_REQUEST",
            SUCCESS: "GET_IAMSMART_PROFILE_SUCCESS",
            FAIL: "GET_IAMSMART_PROFILE_FAIL",
            DONE: "GET_IAMSMART_PROFILE_DONE",
        },
        GET_SIGNING: {
            REQUEST: "GET_SIGNING_REQUEST",
            SUCCESS: "GET_SIGNING_SUCCESS",
            FAIL: "GET_SIGNING_FAIL",
        },
        GET_SIGNING_RESULT: {
            REQUEST: "GET_SIGNING_RESULT_REQUEST",
            SUCCESS: "GET_SIGNING_RESULT_SUCCESS",
            FAIL: "GET_SIGNING_RESULT_FAIL",
        },
        GET_ANON_SIGNING_QR: {
            REQUEST: "GET_ANON_SIGNING_QR_REQUEST",
            SUCCESS: "GET_ANON_SIGNING_QR_SUCCESS",
            FAIL: "GET_ANON_SIGNING_QR_FAIL",
        },
        GET_ANON_SIGNING_RESULT: {
            REQUEST: "GET_ANON_SIGNING_RESULT_REQUEST",
            SUCCESS: "GET_ANON_SIGNING_RESULT_SUCCESS",
            FAIL: "GET_ANON_SIGNING_RESULT_FAIL",
        },
        PRINT_LOGS: {
            REQUEST: "PRINT_LOGS_RESULT_REQUEST",
            SUCCESS: "PRINT_LOGS_RESULT_SUCCESS",
            FAIL: "PRINT_LOGS_RESULT_FAIL",
        },
        COMMON_PRINT_LOGS: {
            REQUEST: "COMMON_PRINT_LOGS_RESULT_REQUEST",
            SUCCESS: "COMMON_PRINT_LOGS_RESULT_SUCCESS",
            FAIL: "COMMON_PRINT_LOGS_RESULT_FAIL",
        },
        GET_ANON_FORM_FILLING_QR: {
            REQUEST: "GET_ANON_FORM_FILLING_QR_REQUEST",
            SUCCESS: "GET_ANON_FORM_FILLING_QR_SUCCESS",
            FAIL: "GET_ANON_FORM_FILLING_QR_FAIL",
        },
        GET_ANON_FORM_FILLING_RESULT: {
            REQUEST: "GET_ANON_FORM_FILLING_RESULT_REQUEST",
            SUCCESS: "GET_ANON_FORM_FILLING_RESULT_SUCCESS",
            FAIL: "GET_ANON_FORM_FILLING_RESULT_FAIL",
        },

        GET_ANON_COMBINE_CALL_RESULT: {
            REQUEST: "GET_ANON_COMBINE_CALL_RESULT_REQUEST",
            SUCCESS: "GET_ANON_COMBINE_CALL_RESULT_SUCCESS",
            FAIL: "GET_ANON_COMBINE_CALL_RESULT_FAIL",
        },
        GET_FORM_PRE_FILL_RESULT: {
            REQUEST: "GET_FORM_PRE_FILL_RESULT_REQUEST",
            SUCCESS: "GET_FORM_PRE_FILL_RESULT_SUCCESS",
            FAIL: "GET_FORM_PRE_FILL_RESULT_FAIL",
        },
        GET_FORM_PRE_FILL: {
            REQUEST: "GET_FORM_PRE_FILL_REQUEST",
            SUCCESS: "GET_FORM_PRE_FILL_SUCCESS",
            FAIL: "GET_FORM_PRE_FILL_FAIL",
        },
        LOGIN: {
            REQUEST: "LOGIN_REQUEST",
            SUCCESS: "LOGIN_SUCCESS",
            FAIL: "LOGIN_FAIL",
        },
        PUBLIC_OTP: {
            REQUEST: "PUBLIC_OTP_REQUEST",
            SUCCESS: "PUBLIC_OTP_SUCCESS",
            FAIL: "PUBLIC_OTP_FAIL",
        },
        PUBLIC_LOGIN: {
            REQUEST: "PUBLIC_LOGIN_REQUEST",
            SUCCESS: "PUBLIC_LOGIN_SUCCESS",
            FAIL: "PUBLIC_LOGIN_FAIL",
        },
        PARAMETER_PAGE: {
            REQUEST: "PARAMETER_PAGE_REQUEST",
            SUCCESS: "PARAMETER_PAGE_SUCCESS",
            FAIL: "PARAMETER_PAGE_FAIL",
        },
        FORM_PARAMETER: {
            REQUEST: "FORM_PARAMETER_REQUEST",
            SUCCESS: "FORM_PARAMETER_SUCCESS",
            FAIL: "FORM_PARAMETER_FAIL",
        },
        GET_PARAMS: {
            REQUEST: "GET_PARAMS_REQUEST",
            SUCCESS: "GET_PARAMS_SUCCESS",
            FAIL: "GET_PARAMS_FAIL",
            DONE: "GET_PARAMS_DONE",
        },
        GET_LATEST_PARAMS: {
            REQUEST: "GET_LATEST_PARAMS_REQUEST",
            SUCCESS: "GET_LATEST_PARAMS_SUCCESS",
            FAIL: "GET_LATEST_PARAMS_FAIL",
            DONE: "GET_LATEST_PARAMS_DONE",
        },
        SUBMIT_PARAMS: {
            REQUEST: "SUBMIT_PARAMS_REQUEST",
            SUCCESS: "SUBMIT_PARAMS_SUCCESS",
            FAIL: "SUBMIT_PARAMS_FAIL",
        },
        SUBMIT_CCC_DATA: {
            REQUEST: "SUBMIT_CCC_DATA_REQUEST",
            SUCCESS: "SUBMIT_CCC_DATA_SUCCESS",
            FAIL: "SUBMIT_CCC_DATA_FAIL",
        },
        GET_CLO_INFO: {
            REQUEST: "GET_CLO_INFO_REQUEST",
            SUCCESS: "GET_CLO_INFO_SUCCESS",
            FAIL: "GET_CLO_INFO_FAIL",
            DONE: "GET_CLO_INFO_DONE",
        },
        GET_APPROVAL_FORM: {
            REQUEST: "GET_APPROVAL_FORM_REQUEST",
            SUCCESS: "GET_APPROVAL_FORM_SUCCESS",
            FAIL: "GET_APPROVAL_FORM_FAIL",
        },
        GET_FORM_TEMP: {
            REQUEST: "GET_FORM_TEMP_REQUEST",
            SUCCESS: "GET_FORM_TEMP_SUCCESS",
            FAIL: "GET_FORM_TEMP_FAIL",
            DONE: "GET_FORM_TEMP_DONE",
        },
        GET_APPROVER_EDIT_FORM_TEMP: {
            REQUEST: "GET_APPROVER_EDIT_FORM_REQUEST",
            SUCCESS: "GET_APPROVER_EDIT_FORM_SUCCESS",
            FAIL: "GET_APPROVER_EDIT_FORM_FAIL",
            DONE: "GET_APPROVER_EDIT_FORM_DONE",
        },
        SUBMIT_FORM: {
            REQUEST: "SUBMIT_FORM_REQUEST",
            SUCCESS: "SUBMIT_FORM_SUCCESS",
            FAIL: "SUBMIT_FORM_FAIL",
            DONE: "SUBMIT_FORM_DONE",
        },
        SUBMIT_FORM_TEMP: {
            REQUEST: "SUBMIT_FORM_TEMP_REQUEST",
            SUCCESS: "SUBMIT_FORM_TEMP_SUCCESS",
            FAIL: "SUBMIT_FORM_TEMP_FAIL",
        },
        APPROVER_EDIT_FORM_TEMP: {
            REQUEST: "APPROVER_EDIT_FORM_TEMP_REQUEST",
            SUCCESS: "APPROVER_EDIT_FORM_TEMP_SUCCESS",
            FAIL: "APPROVER_EDIT_FORM_TEMP_FAIL",
        },
        APPROVAL_FLOW: {
            REQUEST: "FORM_APPROVAL_REQUEST",
            SUCCESS: "FORM_APPROVAL_SUCCESS",
            FAIL: "FORM_APPROVAL_FAIL",
        },
        GET_ATTACHMENT: {
            REQUEST: "GET_ATTACHMENT_REQUEST",
            SUCCESS: "GET_ATTACHMENT_SUCCESS",
            FAIL: "GET_ATTACHMENT_FAIL",
        },
        SUBMIT_ATTACHMENT: {
            REQUEST: "SUBMIT_ATTACHMENT_REQUEST",
            SUCCESS: "SUBMIT_ATTACHMENT_SUCCESS",
            FAIL: "SUBMIT_ATTACHMENT_FAIL",
        },
        DELETE_ATTACHMENT: {
            REQUEST: "DELETE_ATTACHMENT_REQUEST",
            SUCCESS: "DELETE_ATTACHMENT_SUCCESS",
            FAIL: "DELETE_ATTACHMENT_FAIL",
        },
        CHANGE_PASSWORD: {
            REQUEST: "CHANGE_PASSWORD_REQUEST",
            SUCCESS: "CHANGE_PASSWORD_SUCCESS",
            FAIL: "CHANGE_PASSWORD_FAIL",
        },
        UPLOAD_SIGNATURE: {
            REQUEST: "UPLOAD_SIGNATURE_REQUEST",
            SUCCESS: "UPLOAD_SIGNATURE_SUCCESS",
            FAIL: "UPLOAD_SIGNATURE_FAIL",
        },
        FORGOT_PASSWORD: {
            REQUEST: "FORGOT_PASSWORD_REQUEST",
            SUCCESS: "FORGOT_PASSWORD_SUCCESS",
            FAIL: "FORGOT_PASSWORD_FAIL",
        },
        GET_STAFF: {
            REQUEST: "GET_STAFF_REQUEST",
            SUCCESS: "GET_STAFF_SUCCESS",
            FAIL: "GET_STAFF_FAIL",
        },
        UPDATE_STAFF: {
            REQUEST: "UPDATE_STAFF_REQUEST",
            SUCCESS: "UPDATE_STAFF_SUCCESS",
            FAIL: "UPDATE_STAFF_FAIL",
        },
        ADD_STAFF: {
            REQUEST: "ADD_STAFF_REQUEST",
            SUCCESS: "ADD_STAFF_SUCCESS",
            FAIL: "ADD_STAFF_FAIL",
        },
        REMOVE_STAFF: {
            REQUEST: "REMOVE_STAFF_REQUEST",
            SUCCESS: "REMOVE_STAFF_SUCCESS",
            FAIL: "REMOVE_STAFF_FAIL",
        },
        GET_ORGANIZATION: {
            REQUEST: "GET_ORGANIZATION_REQUEST",
            SUCCESS: "GET_ORGANIZATION_SUCCESS",
            FAIL: "GET_ORGANIZATION_FAIL",
        },
        ADD_ORGANIZATION: {
            REQUEST: "ADD_ORGANIZATION_REQUEST",
            SUCCESS: "ADD_ORGANIZATION_SUCCESS",
            FAIL: "ADD_ORGANIZATION_FAIL",
        },
        REMOVE_ORGANIZATION: {
            REQUEST: "REMOVE_ORGANIZATION_REQUEST",
            SUCCESS: "REMOVE_ORGANIZATION_SUCCESS",
            FAIL: "REMOVE_ORGANIZATION_FAIL",
        },
        ADD_ORGANIZATION_ADMIN: {
            REQUEST: "ADD_ORGANIZATION_ADMIN_REQUEST",
            SUCCESS: "ADD_ORGANIZATION_ADMIN_SUCCESS",
            FAIL: "ADD_ORGANIZATION_ADMIN_FAIL",
        },
        REMOVE_ORGANIZATION_ADMIN: {
            REQUEST: "REMOVE_ORGANIZATION_ADMIN_REQUEST",
            SUCCESS: "REMOVE_ORGANIZATION_ADMIN_SUCCESS",
            FAIL: "REMOVE_ORGANIZATION_ADMIN_FAIL",
        },
        GET_REVIEWER: {
            REQUEST: "GET_REVIEWER_REQUEST",
            SUCCESS: "GET_REVIEWER_SUCCESS",
            FAIL: "GET_REVIEWER_FAIL",
        },
        ADD_REVIEWER: {
            REQUEST: "ADD_REVIEWER_REQUEST",
            SUCCESS: "ADD_REVIEWER_SUCCESS",
            FAIL: "ADD_REVIEWER_FAIL",
        },
        REMOVE_REVIEWER: {
            REQUEST: "REMOVE_REVIEWER_REQUEST",
            SUCCESS: "REMOVE_REVIEWER_SUCCESS",
            FAIL: "REMOVE_REVIEWER_FAIL",
        },
        GET_FORM_OWNER: {
            REQUEST: "GET_FORM_OWNER_REQUEST",
            SUCCESS: "GET_FORM_OWNER_SUCCESS",
            FAIL: "GET_FORM_OWNER_FAIL",
        },
        ADD_FORM_OWNER: {
            REQUEST: "ADD_FORM_OWNER_REQUEST",
            SUCCESS: "ADD_FORM_OWNER_SUCCESS",
            FAIL: "ADD_FORM_OWNER_FAIL",
        },
        REMOVE_FORM_OWNER: {
            REQUEST: "REMOVE_FORM_OWNER_REQUEST",
            SUCCESS: "REMOVE_FORM_OWNER_SUCCESS",
            FAIL: "REMOVE_FORM_OWNER_FAIL",
        },
        GET_FORM_DELEGATION: {
            REQUEST: "GET_FORM_DELEGATION_REQUEST",
            SUCCESS: "GET_FORM_DELEGATION_SUCCESS",
            FAIL: "GET_FORM_DELEGATION_FAIL",
        },
        GET_RELATED_DELEGATION_USER: {
            REQUEST: "GET_RELATED_DELEGATION_USER_REQUEST",
            SUCCESS: "GET_RELATED_DELEGATION_USER_SUCCESS",
            FAIL: "GET_RELATED_DELEGATION_USER_FAIL",
        },
        GET_SPECIFIC_DELEGATION: {
            REQUEST: "GET_SPECIFIC_DELEGATION_REQUEST",
            SUCCESS: "GET_SPECIFIC_DELEGATION_SUCCESS",
            FAIL: "GET_SPECIFIC_DELEGATION_FAIL",
        },
        GET_USER_PROFILE: {
            REQUEST: "GET_USER_PROFILE_REQUEST",
            SUCCESS: "GET_USER_PROFILE_SUCCESS",
            FAIL: "GET_USER_PROFILE_FAIL",
            DONE: "GET_USER_PROFILE_DONE",
        },
        SET_USER_PROFILE: {
            REQUEST: "SET_USER_PROFILE_REQUEST",
            SUCCESS: "SET_USER_PROFILE_SUCCESS",
            FAIL: "SET_USER_PROFILE_FAIL",
        },
        UN_LINK_IMASMART: {
            REQUEST: "UN_LINK_IMASMART_REQUEST",
            SUCCESS: "UN_LINK_IMASMART_SUCCESS",
            FAIL: "UN_LINK_IMASMART_FAIL",
        },
        GET_DELEGATION: {
            REQUEST: "GET_DELEGATION_REQUEST",
            SUCCESS: "GET_DELEGATION_SUCCESS",
            FAIL: "GET_DELEGATION_FAIL",
        },
        GET_RELATED_USER: {
            REQUEST: "GET_RELATED_USER_REQUEST",
            SUCCESS: "GET_RELATED_USER_SUCCESS",
            FAIL: "GET_RELATED_USER_FAIL",
        },
        SUBMIT_SPECIFIC_DELEGATION: {
            REQUEST: "SUBMIT_SPECIFIC_DELEGATION_REQUEST",
            SUCCESS: "SUBMIT_SPECIFIC_DELEGATION_SUCCESS",
            FAIL: "SUBMIT_SPECIFIC_DELEGATION_FAIL",
        },
        SUBMIT_FORM_DELEGATION: {
            REQUEST: "SUBMIT_FORM_DELEGATION_REQUEST",
            SUCCESS: "SUBMIT_FORM_DELEGATION_SUCCESS",
            FAIL: "SUBMIT_FORM_DELEGATION_FAIL",
        },
        PARSE_TOKEN: {
            REQUEST: "PARSE_TOKEN_REQUEST",
            SUCCESS: "PARSE_TOKEN_SUCCESS",
            FAIL: "PARSE_TOKEN_FAIL",
        },
        SEND_FORM_ENQUIRY: {
            REQUEST: "SEND_FORM_ENQUIRY_REQUEST",
            SUCCESS: "SEND_FORM_ENQUIRY_SUCCESS",
            FAIL: "SEND_FORM_ENQUIRY_FAIL",
        },
        HEALTH_CHECK: {
            REQUEST: "HEALTH_CHECK_REQUEST",
            SUCCESS: "HEALTH_CHECK_SUCCESS",
            FAIL: "HEALTH_CHECK_FAIL",
        },
        MONTHLY_SUBMISSION_REPORT: {
            REQUEST: "MONTHLY_SUBMISSION_REPORT_REQUEST",
            SUCCESS: "MONTHLY_SUBMISSION_REPORT_SUCCESS",
            FAIL: "MONTHLY_SUBMISSION_REPORT_FAIL",
        },
        DOWNLOAD_ZIP: {
            REQUEST: "DOWNLOAD_ZIP_REQUEST",
            SUCCESS: "DOWNLOAD_ZIP_SUCCESS",
            FAIL: "DOWNLOAD_ZIP_FAIL",
        },
        GET_REPORT: {
            REQUEST: "GET_REPORT_REQUEST",
            SUCCESS: "GET_REPORT_SUCCESS",
            FAIL: "GET_REPORT_FAIL",
        },
        GET_WORK_FLOW_USER: {
            REQUEST: "GET_WORK_FLOW_USER_REQUEST",
            SUCCESS: "GET_WORK_FLOW_USER_SUCCESS",
            FAIL: "GET_WORK_FLOW_USER_FAIL",
        },
        GET_DELEGATION_FORM_DROPDOWN: {
            REQUEST: "GET_DELEGATION_FORM_DROPDOWN_REQUEST",
            SUCCESS: "GET_DELEGATION_FORM_DROPDOWN_SUCCESS",
            FAIL: "GET_DELEGATION_FORM_DROPDOWN_FAIL",
        },
        IAMSMART_LOGIN: {
            REQUEST: "IAMSMART_LOGIN_REQUEST",
            SUCCESS: "IAMSMART_LOGIN_SUCCESS",
            FAIL: "IAMSMART_LOGIN_FAIL",
        },
        LINK_UP_OTP: {
            REQUEST: "LINK_UP_OTP_REQUEST",
            SUCCESS: "LINK_UP_OTP_SUCCESS",
            FAIL: "LINK_UP_OTP_FAIL",
        },
        IAMSMART_LINK_UP: {
            REQUEST: "IAMSMART_LINK_UP_REQUEST",
            SUCCESS: "IAMSMART_LINK_UP_SUCCESS",
            FAIL: "IAMSMART_LINK_UP_FAIL",
        },
        GET_FORM_STATUS: {
            REQUEST: "GET_FORM_STATUS_REQUEST",
            SUCCESS: "GET_FORM_STATUS_SUCCESS",
            FAIL: "GET_FORM_STATUS_FAIL",
        },
        GET_FORM_LAYER: {
            REQUEST: "GET_FORM_LAYER_REQUEST",
            SUCCESS: "GET_FORM_LAYER_SUCCESS",
            FAIL: "GET_FORM_LAYER_FAIL",
        },
        GET_APPLICANT_FORM_LIST: {
            REQUEST: "GET_APPLICANT_FORM_LIST_REQUEST",
            SUCCESS: "GET_APPLICANT_FORM_LIST_SUCCESS",
            FAIL: "GET_APPLICANT_FORM_LIST_FAIL",
        },
        UPDATE_APPLICANT_SELECTED_SCRN: {
            REQUEST: "UPDATE_APPLICANT_SELECTED_SCRN_REQUEST",
            SUCCESS: "UPDATE_APPLICANT_SELECTED_SCRN_SUCCESS",
            FAIL: "UPDATE_APPLICANT_SELECTED_SCRN_FAIL",
        },
        GET_FORM_TITLE_PARAM: {
            REQUEST: "GET_FORM_TITLE_PARAM_REQUEST",
            SUCCESS: "GET_FORM_TITLE_PARAM_SUCCESS",
            FAIL: "GET_FORM_TITLE_PARAM_FAIL",
        },
        SET_FORM_TITLE_PARAM_LIST: "SET_FORM_TITLE_PARAM_LIST",
        RESET_FORM_TITLE_PARAM_LIST: "RESET_FORM_TITLE_PARAM_LIST",
        GET_DISTRICTS: {
            REQUEST: "GET_DISTRICTS_REQUEST",
            SUCCESS: "GET_DISTRICTS_SUCCESS",
            FAIL: "GET_DISTRICTS_FAIL",
        },
        UPDATE_DISTRICTS: {
            REQUEST: "UPDATE_DISTRICTS_REQUEST",
            SUCCESS: "UPDATE_DISTRICTS_SUCCESS",
            FAIL: "UPDATE_DISTRICTS_FAIL",
        },
        GET_KGCCC_SCRN: {
            REQUEST: "GET_KGCCC_SCRN_REQUEST",
            SUCCESS: "GET_KGCCC_SCRN_SUCCESS",
            FAIL: "GET_KGCCC_SCRN_FAIL",
        },
        SET_KGCCC_SCRN: "SET_KGCCC_SCRN",
        SET_SCHOOL_LIST: "SET_SCHOOL_LIST",
        GET_REVIEWER_DROPDOWN: {
            REQUEST: "GET_REVIEWER_DROPDOWN_REQUEST",
            SUCCESS: "GET_REVIEWER_DROPDOWN_SUCCESS",
            FAIL: "GET_REVIEWER_DROPDOWN_FAIL",
        },

        GET_FORM_SELECTION_LIST: "GET_FORM_SELECTION_LIST",
        SEND_FORM_HISTORY_ENQUIRY: "SEND_FORM_HISTORY_ENQUIRY",
        DOWNLOAD_HISTORY_ZIP: "DOWNLOAD_HISTORY_ZIP",
        SET_EFFECTIVE_JOB: "SET_EFFECTIVE_JOB",
        GET_EFFECTIVE_HKID: {
            REQUEST: "GET_EFFECTIVE_HKID_REQUEST",
            SUCCESS: "GET_EFFECTIVE_HKID_SUCCESS",
            FAIL: "GET_EFFECTIVE_HKID_FAIL",
        },
        SET_FORM101_SUBMITED_JOB: "SET_FORM101_SUBMITED_JOB",
        SET_FORM_ENTER_LOCALTIME: "SET_FORM_ENTER_LOCALTIME",
        SET_SERVERTIME: "SET_SERVERTIME",
        SET_SSLO_RESET_PASSWORD_TIME: "SET_SSLO_RESET_PASSWORD_TIME",
        SET_PUBLIC_RESET_PASSWORD_TIME: "SET_PUBLIC_RESET_PASSWORD_TIME",
        GET_COLLBOX_GROUP: {
            REQUEST: "GET_COLLBOX_GROUP_REQUEST",
            SUCCESS: "GET_COLLBOX_GROUP_SUCCESS",
            FAIL: "GET_COLLBOX_GROUP_FAIL",
        },
        ADD_COLLBOX_GROUP: {
            REQUEST: "ADD_COLLBOX_GROUP_REQUEST",
            SUCCESS: "ADD_COLLBOX_GROUP_SUCCESS",
            FAIL: "ADD_COLLBOX_GROUP_FAIL",
        },
        EDIT_COLLBOX_GROUP: {
            REQUEST: "EDIT_COLLBOX_GROUP_REQUEST",
            SUCCESS: "EDIT_COLLBOX_GROUP_SUCCESS",
            FAIL: "EDIT_COLLBOX_GROUP_FAIL",
        },
        GET_COLLBOX_FORM_NAME: {
            REQUEST: "GET_COLLBOX_FORM_NAME_REQUEST",
            SUCCESS: "GET_COLLBOX_FORM_NAME_SUCCESS",
            FAIL: "GET_COLLBOX_FORM_NAME_FAIL",
        },
        ADD_COLLBOX_FORM_NAME: {
            REQUEST: "ADD_COLLBOX_FORM_NAME_REQUEST",
            SUCCESS: "ADD_COLLBOX_FORM_NAME_SUCCESS",
            FAIL: "ADD_COLLBOX_FORM_NAME_FAIL",
        },
        EDIT_COLLBOX_FORM_NAME: {
            REQUEST: "EDIT_COLLBOX_FORM_NAME_REQUEST",
            SUCCESS: "EDIT_COLLBOX_FORM_NAME_SUCCESS",
            FAIL: "EDIT_COLLBOX_FORM_NAME_FAIL",
        },
        ADD_COLLBOX_REVIEWER: {
            REQUEST: "ADD_COLLBOX_REVIEWER_REQUEST",
            SUCCESS: "ADD_COLLBOX_REVIEWER_SUCCESS",
            FAIL: "ADD_COLLBOX_REVIEWER_FAIL",
        },
        EDIT_COLLBOX_REVIEWER: {
            REQUEST: "EDIT_COLLBOX_REVIEWER_REQUEST",
            SUCCESS: "EDIT_COLLBOX_REVIEWER_SUCCESS",
            FAIL: "EDIT_COLLBOX_REVIEWER_FAIL",
        },
        DELETE_COLLBOX_REVIEWER: {
            REQUEST: "DELETE_COLLBOX_REVIEWER_REQUEST",
            SUCCESS: "DELETE_COLLBOX_REVIEWER_SUCCESS",
            FAIL: "DELETE_COLLBOX_REVIEWER_FAIL",
        },
        SET_ALL_COLLBOX_GROUP_AUTH: "SET_ALL_COLLBOX_GROUP_AUTH",
        GET_PDF_DIGEST: {
            REQUEST: "GET_PDF_DIGEST_REQUEST",
            SUCCESS: "GET_PDF_DIGEST_SUCCESS",
            FAIL: "GET_PDF_DIGEST_FAIL",
        },
        GET_PDF_SIGN: {
            REQUEST: "GET_PDF_SIGN_REQUEST",
            SUCCESS: "GET_PDF_SIGN_SUCCESS",
            FAIL: "GET_PDF_SIGN_FAIL",
        },
        SAVE_FORM107_DRAFT: "SAVE_FORM107_DRAFT",
        SET_MODE: "SET_MODE",
    },

    // List of forms with only iam smart signing
    onlyIamSmartSigningList: [
        "Form001",
        "Form003",
        "Form007",
        "Form014",
        "Form015",
        "Form016",
        "Form017",
        "Form018",
        "Form028",
        "Form029",
        "Form030",
        "Form040",
        "Form041",
        "Form042",
        "Form043",
        "Form044",
        "Form045",
        "Form046",
        "Form047",
        "Form048",
        "Form049",
        "Form050",
        "Form052",
        "Form053",
        "Form054",
        "Form057",
        "Form058",
        "Form059",
        "Form062",
        "Form063",
        "Form064",
        "Form065",
        "Form066",
        "Form067",
        "Form068",
        "Form069",
        "Form070",
        "Form071",
        "Form073",
        "Form074",
        "Form078",
        "Form081",
        "Form082",
        "Form083",
        "Form084",
        "Form092",
        "Form093",
        "Form094",
        "Form095",
        "Form102",
        "Form103",
        "Form106",
    ],

    // 1 st Approver (status = 1)
    SubmitLayer1: [
        //"Form001",
        "Form003",
        "Form009",
        "Form008",
        "Form009",
        "Form010",
        "Form011",
        "Form012",
        "Form013",
        // "Form014",
        "Form021",
        "Form022",
        "Form023",
        "Form028",
        "Form029",
        "Form031",
        "Form032",
        "Form033",
        "Form034",
        "Form035",
        "Form040",
        "Form043",
        "Form044",
        "Form045",
        "Form046",
        "Form048",
        "Form049",
        "Form072",
        // "Form074",
        // "Form075",
        "Form080",
        "Form083",
        "Form084",
        // "Form087",
        "Form090",
        "Form091",
        "Form094",
        "Form093",
        "Form097",
        "Form098",
        "Form099",
    ],

    // 2 nd Approver (status = 3)
    SubmitLayer2: [
        "Form008",
        "Form010",
        "Form012",
        "Form028",
        "Form033",
        "Form080",
        "Form083",
        "Form084",
        "Form092",
        "Form095",
        "Form097",
        // "Form098",
    ],

    // 3 st Approver (status = 5)
    SubmitLayer3: ["Form008", "Form098"],

    // 4 st Approver (status = 7)
    SubmitLayer4: ["Form098"],

    // 5 st Approver (status = 9)
    SubmitLayer5: ["Form016", "Form017", "Form018", "Form010"],

    // List of form with only digital signing
    digitSignOnlyList: [],

    // List of form with exclude iam smart signing
    excludeIamSmartSigningList: [
        "Form072",
        "Form076",
        "Form021",
        "Form099",
        "Form087",
        "Form107",
    ],

    EDBName: "Education Bureau",

    // cancel autofill for Input autoComplete
    autoCompleteOffList: [
        "Form040",
        "Form041",
        "Form042",
        "Form043",
        "Form044",
        "Form045",
        "Form046",
        "Form047",
        "Form048",
        "Form049",
        "Form050",
    ],

    //Form add Parameter Tooltip
    ParameterTooltipList: ["Form014"],

    formHotLine: [
        { id: 1, hotline: "3509 7395", section: "HKSES" },
        { id: 2, hotline: "2892 6660", section: "ESP" },
        { id: 3, hotline: "3850 2035", section: "SSSSKT" },
        { id: 4, specialSentence: "form_4" },
        { id: 5, hotline: "2892 6653", section: "ESP" },
        { id: 6, hotline: "2892 6653", section: "ESP" },
        { id: 7, hotline: "2892 6653", section: "ESP" },
        { id: 8, hotline: "2892 6660", section: "ESP" },
        { id: 9, hotline: "2892 6660", section: "ESP" },
        { id: 10, hotline: "2892 6660", section: "ESP" },
        { id: 11, hotline: "2892 6660", section: "ESP" },

        { id: 12, hotline: "2892 6653", section: "ESP" },
        { id: 13, hotline: "2892 6653", section: "ESP" },
        { id: 14, hotline: "3698 3663 / 3698 3647", section: "TDT" },
        { id: 15, hotline: "3467 8282", section: "TRTEB" },
        { id: 16, hotline: "3509 7471", section: "SLPDS" },
        { id: 17, hotline: "3509 7471", section: "SLPDS" },
        { id: 18, hotline: "3509 7471", section: "SLPDS" },

        { id: 19, specialSentence: "form_19_20_21" },
        { id: 20, specialSentence: "form_19_20_21" },
        { id: 21, specialSentence: "form_19_20_21" },

        { id: 22, specialSentence: "form_22_24" },
        { id: 24, specialSentence: "form_22_24" },

        { id: 23, specialSentence: "form_23_25" },
        { id: 25, specialSentence: "form_23_25" },

        { id: 26, hotline: "2892 5729", section: "TALTQS" },
        { id: 27, hotline: "2892 5786", section: "TALTQS" },
        { id: 28, hotline: "3467 8282", section: "TRTEB" },
        { id: 29, hotline: "3467 8282", section: "TRTEB" },

        { id: 30, specialSentence: "form_30" },
        { id: 31, specialSentence: "form_31" },
        { id: 32, specialSentence: "form_31" }, //same with 31
        { id: 33, specialSentence: "form_31" }, //same with 31
        { id: 34, specialSentence: "form_31" }, //same with 31
        { id: 35, specialSentence: "form_31" }, //same with 31
        { id: 36, specialSentence: "form_31" }, //same with 31
        { id: 37, specialSentence: "form_31" }, //same with 31
        { id: 38, specialSentence: "form_31" }, //same with 31
        { id: 39, specialSentence: "form_31" }, //same with 31

        { id: 40, hotline: "3107 2197", section: "JOKCCC" },
        { id: 41, hotline: "3107 2197", section: "JOKCCC" },
        { id: 42, hotline: "3107 2197", section: "JOKCCC" },
        { id: 43, hotline: "3107 2197", section: "JOKCCC" },
        { id: 44, hotline: "3107 2197", section: "JOKCCC" },
        { id: 45, hotline: "3107 2197", section: "JOKCCC" },
        { id: 46, hotline: "3107 2197", section: "JOKCCC" },
        { id: 47, hotline: "3107 2197", section: "JOKCCC" },
        { id: 48, hotline: "3107 2197", section: "JOKCCC" },
        { id: 49, hotline: "3107 2197", section: "JOKCCC" },
        { id: 50, hotline: "3107 2197", section: "JOKCCC" },

        { id: 51, hotline: "3698 3909", section: "EAS" },

        { id: 52, specialSentence: "form_52" },
        { id: 53, specialSentence: "form_52" },

        { id: 54, specialSentence: "form_52" },
        { id: 55, specialSentence: "form_52" },
        { id: 56, specialSentence: "form_52" },
        { id: 57, specialSentence: "form_52" },
        { id: 58, specialSentence: "form_52" },

        { id: 59, hotline: "3509 8924", section: "SDD_CT2" },
        { id: 60, hotline: "3509 8924", section: "SDD_CT2" },
        { id: 61, hotline: "3509 8924", section: "SDD_CT2" },

        { id: 62, section: "RSSDO" },

        { id: 63, specialSentence: "form_63_64_65_66_71" },
        { id: 64, specialSentence: "form_63_64_65_66_71" },
        { id: 65, specialSentence: "form_63_64_65_66_71" },
        { id: 66, specialSentence: "form_63_64_65_66_71" },
        { id: 67, specialSentence: "form_67_68" },
        { id: 68, specialSentence: "form_67_68" },
        { id: 69, specialSentence: "form_69_70" },
        { id: 70, specialSentence: "form_69_70" },

        { id: 71, specialSentence: "form_63_64_65_66_71" },

        { id: 72, hotline: "3509 8664", section: "SA4S" },

        { id: 73, specialSentence: "form_73_74" },
        { id: 74, specialSentence: "form_73_74" },
        { id: 75, hotline: "2892 6188 / 2892 6163", section: "PSS" },
        { id: 76, hotline: "2892 6192", section: "PSS" },
        { id: 78, specialSentence: "form_78_81" },
        { id: 79, hotline: "2892 6189 / 2892 6191", section: "PSS" },

        { id: 80, hotline: "3698 4296 / 3698 4335", section: "PSS" },
        { id: 81, specialSentence: "form_78_81" },
        { id: 82, specialSentence: "form_82" },
        { id: 83, specialSentence: "form_83_84" },
        { id: 84, specialSentence: "form_83_84" },

        { id: 85, hotline: "3698 3493", section: "GES" },
        { id: 86, hotline: "3698 3493", section: "GES" },
        { id: 87, hotline: "3698 3430", section: "GES" },
        { id: 88, hotline: "3698 3480", section: "GES" },
        { id: 89, hotline: "3540 7436", section: "LLS" },
        { id: 90, hotline: "2892 5895 / 2892 6433", section: "CSS1" },
        { id: 91, hotline: "3698 3486", section: "CDO10" },

        { id: 92, hotline: "2892 6222", section: "FS" },
        { id: 93, hotline: "2892 6222", section: "FS" },
        { id: 94, specialSentence: "form_94" },
        { id: 95, hotline: "2892 6222", section: "FS" },

        { id: 96, hotline: "2892 6325", section: "GSS" },
        { id: 97, hotline: "2892 6325", section: "GSS" },
        { id: 98, hotline: "2892 6325", section: "GSS" },
        { id: 99, hotline: "3698 3477", section: "GES" },
        { id: 100, hotline: "3509 8413", section: "IISS" },
        { id: 101, specialSentence: "form_101" },
        { id: 102, hotline: "2186 6430", section: "SRCS" },
        { id: 103, hotline: "2186 6420", section: "SRCS" },
        { id: 104, hotline: "3904 1349", section: "SRCS" },
        { id: 106, hotline: "2158 4939", section: "SES3S" },
        { id: 107, hotline: "3467 8275 or 2780 8145", section: "TRS" },
    ],

    previewPDFTooltipList: ["Form072"],

    specialStylePICSFormList: ["Form101"],

    approverSaveFormList: [
        "Form002",
        "Form008",
        "Form009",
        "Form010",
        "Form011",
    ],

    emailTemplateFormList: [
        "30",
        "52",
        "53",
        "54",
        "57",
        "58",
        "69",
        "70",
        "73",
        "74",
    ],
    //chage Form submitEdited button description
    submitEditedFormlist: ["Form083", "Form084"],

    advSearchFormField: {
        Form002: ["applicantName", "schoolName"],
        Form008: ["applicantName", "schoolName"],
        Form009: ["applicantName", "schoolName"],
        Form010: ["applicantName", "schoolName"],
        Form011: ["applicantName", "schoolName"],
        Form013: [
            "ngoNameEng",
            "ngoNameChi",
            "departmentName",
            "coordinatorName",
            "coordinatorTelNo",
            "coordinatorMobile",
        ],
        Form014: ["applicantName", "schoolName", "schltele"],
        Form030: ["treaSchlCode", "schlLevlType"],
        Form040: ["schoolName"],
        Form041: ["schoolName"],
        Form042: ["schoolName"],
        Form043: ["schoolName"],
        Form044: ["schoolName"],
        Form045: ["schoolName"],
        Form046: ["schoolName"],
        Form047: ["schoolName"],
        Form048: ["schoolName"],
        Form049: ["schoolName"],
        Form050: ["schoolName"],
        Form052: ["treaSchlCode", "schlLevlType"],
        Form053: ["treaSchlCode", "schlLevlType"],
        Form054: ["treaSchlCode", "schlLevlType"],
        Form057: ["treaSchlCode", "schlLevlType"],
        Form058: ["treaSchlCode", "schlLevlType"],
        Form069: ["treaSchlCode", "schlLevlType"],
        Form070: ["treaSchlCode", "schlLevlType"],
        Form073: ["treaSchlCode", "schlLevlType"],
        Form074: ["treaSchlCode", "schlLevlType"],
        Form075: ["applicantName", "schoolName", "telNo"],
        Form089: ["schoolName"],
        Form092: [
            "nameOfContributorEN",
            "nameOfContributorCH",
            "telNo",
            "schoolName",
            "staffNo",
        ],
        Form095: [
            "nameOfContributorEN",
            "nameOfContributorCH",
            "telNo",
            "schoolName",
            "staffNo",
        ],
        Form097: ["applicantName", "schoolName", "rejectedBy"],
        Form098: ["applicantName", "schoolName"],
        Form101: [
            "applicantName",
            "jobTitle",
            "subject",
            "amended",
            "version",
        ],
        Form102: ["signatureType"],
        Form104: ["scrn", "schoolName", "progressReport"],
        Form105: ["sectionName", "group"],
        Form107: ["createdOrgId"],
    },

    //Form Enquiry Offset
    advSearchResultOffset: {
        Form001: 20,
        Form005: 20,
        Form012: 20,
        Form101: 100,
        Default: 50,
    },

    //need translate SSDO form
    translateSsdoFormList: [
        "Form069",
        "Form070",
        "Form078",
        "Form081",
        "Form082",
    ],
    withdrewForm: [
        "Form030",
        "Form052",
        "Form053",
        "Form054",
        "Form057",
        "Form058",
        "Form069",
        "Form070",
        "Form073",
        "Form074",
        "Form097",
        "Form098",
    ],
    form101AEOAorAIGKey: ["AEOA", "AIG"],
    form101AEOorAPSMKey: ["AEO", "APSM"],
    form101SES1orSES2Key: ["SES1", "SES2"],
    workingExperienceMinimumYears: {
        AEOA: 3,
        AIG: 4,
        SES1: 6,
        SES2: 4,
    },
    advSearchResultExpandApplicantName: [
        "Form002",
        "Form008",
        "Form009",
        "Form010",
        "Form011",
        "Form097",
        "Form098",
        "Form101",
    ],
    advSearchResultExpandFullApplicantName: ["Form014"],
    downloadAttachmentForm: ["Form102"],
    exceedingDeadlineFormList: [
        "Form007",
        "Form009",
        "Form010",
        "Form011",
        "Form013",
        "Form026",
        "Form027",
        "Form075",
        "Form079",
        "Form086",
        "Form087",
        "Form090",
        "Form099",
        "Form106",
    ],
    hideSearchPageRoles: [],
    submitDeadlineKey: {
        Form007: ["deadline"],
        Form009: ["deadLine"],
        Form010: ["deadLine"],
        Form011: ["deadLine"],
        Form013: ["deadline"],
        Form026: [["startDate", "deadLine"]],
        Form027: [["formFillStartDate", "formFillEndDate"]],
        Form075: [["formFillStartDate", "formFillEndDate"]],
        Form079: [["formFillStartDate", "formFillEndDate"]],
        Form086: ["deadline"],
        Form087: [["formFillStartDate", "formFillEndDate"]],
        Form090: ["deadLine"],
        Form099: [["startDate", "deadLine"]],
        Form104: [["applicationStartDate", "applicationEndDate"]],
        Form106: [["startDate", "endDate"]],
    },
    formApplicantLoginMethod: {
        Form001: ["PUBLIC", "IAMSMART"],
        Form002: ["CLO"],
        Form003: ["CLO"],
        Form004: ["SSLO"],
        Form005: ["SSLO"],
        Form006: ["SSLO"],
        Form007: ["CLO"],
        Form008: ["CLO"],
        Form009: ["CLO"],
        Form010: ["CLO"],
        Form011: ["CLO"],
        Form012: ["SSLO"],
        Form013: ["SSLO"],
        Form014: ["CLO"],
        Form015: ["PUBLIC", "IAMSMART"],
        Form016: ["PUBLIC", "IAMSMART"],
        Form017: ["PUBLIC", "IAMSMART"],
        Form018: ["PUBLIC", "IAMSMART"],
        Form019: ["CLO"],
        Form021: ["CLO"],
        Form022: ["CLO"],
        Form023: ["CLO"],
        Form026: ["PUBLIC", "IAMSMART"],
        Form027: ["PUBLIC", "IAMSMART"],
        Form028: ["CLO"],
        Form029: ["PUBLIC", "IAMSMART"],
        Form030: ["CLO"],
        Form031: ["CLO"],
        Form032: ["CLO"],
        Form033: ["CLO"],
        Form034: ["CLO"],
        Form035: ["CLO"],
        Form040: ["CLO"],
        Form041: ["PUBLIC", "IAMSMART"],
        Form042: ["PUBLIC", "IAMSMART"],
        Form043: ["CLO"],
        Form044: ["CLO"],
        Form045: ["CLO"],
        Form046: ["CLO"],
        Form047: ["PUBLIC", "IAMSMART"],
        Form048: ["CLO"],
        Form049: ["CLO"],
        Form050: ["PUBLIC", "IAMSMART"],
        Form051: ["PUBLIC", "IAMSMART"],
        Form052: ["CLO"],
        Form053: ["CLO"],
        Form054: ["CLO"],
        Form057: ["CLO"],
        Form058: ["CLO"],
        Form059: ["CLO"],
        Form062: ["CLO"],
        Form063: ["CLO"],
        Form064: ["CLO"],
        Form065: ["CLO"],
        Form066: ["CLO"],
        Form067: ["CLO"],
        Form068: ["CLO"],
        Form069: ["CLO"],
        Form070: ["CLO"],
        Form071: ["CLO"],
        Form072: ["CLO"],
        Form073: ["CLO"],
        Form074: ["CLO"],
        Form075: ["CLO"],
        Form076: ["PUBLIC", "IAMSMART"],
        Form078: ["CLO"],
        Form079: ["PUBLIC", "IAMSMART"],
        Form080: ["PUBLIC", "IAMSMART"],
        Form081: ["CLO"],
        Form082: ["CLO"],
        Form083: ["CLO"],
        Form084: ["CLO"],
        Form085: ["CLO"],
        Form086: ["CLO"],
        Form087: ["PUBLIC", "IAMSMART"],
        Form088: ["CLO"],
        Form089: ["CLO"],
        Form090: ["CLO"],
        Form091: ["PUBLIC", "IAMSMART"],
        Form092: ["PUBLIC", "IAMSMART"],
        Form093: ["CLO"],
        Form094: ["CLO"],
        Form095: ["PUBLIC", "IAMSMART"],
        Form096: ["PUBLIC", "IAMSMART"],
        Form097: ["CLO"],
        Form098: ["CLO"],
        Form099: ["CLO"],
        Form100: ["PUBLIC", "IAMSMART"],
        Form101: ["PUBLIC", "IAMSMART"],
        Form102: ["SSLO"],
        Form103: ["PUBLIC", "IAMSMART"],
        Form104: ["PUBLIC", "IAMSMART"],
        Form106: ["PUBLIC", "IAMSMART"],
        Form107: ["SSLO"],
    },

};
